/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { TouchableOpacity, View, StyleSheet } from 'react-native';

import Text from './Text';
import Toast from './Toast';
import { themeColors } from './Constants';
import Icon, { IconName, IconSize } from './Icon';

type Type = 'error' | 'success' | 'removed';
type TextType = 'label' | 'regular' | 'heading' | 'title';

type Props = {
  type: Type;
  text: string;
  textStyle?: string;
  textType?: TextType;
  style?: StyleSet;
  onMessage?: () => void;
};

export default function StatusToast(props: Props) {
  let { style, text, textStyle, textType = 'regular', type, onMessage } = props;
  let resolved = statusCheck(type);
  return (
    <Toast
      type={resolved.type}
      loadingColor={resolved.loadingColor}
      toastColor={resolved.container}
    >
      <TouchableOpacity onPress={onMessage}>
        <View style={[styles.contentContainer, style]}>
          <Icon
            name={resolved.iconName}
            size={resolved.iconSize}
            color={resolved.iconColor}
            style={{ marginRight: 20 }}
          />
          <Text type={textType} style={[resolved.text, textStyle as any]}>
            {text}
          </Text>
        </View>
      </TouchableOpacity>
    </Toast>
  );
}

// TODO: This is really verbose; Refactor to be cleaner.
const statusCheck = (
  type: Type,
): {
  type: Type;
  container: string;
  text: StyleSet;
  loadingColor: string;
  iconName: IconName;
  iconColor: string;
  iconSize: IconSize;
  iconStyle?: StyleSet;
} => {
  switch (type) {
    case 'success':
      return {
        type: 'success',
        container: themeColors.greenToast,
        text: styles.successText,
        loadingColor: themeColors.greenToastText,
        iconName: 'roundCheck',
        iconColor: themeColors.greenToastText,
        iconSize: 'M',
      };
    case 'error':
      return {
        type: 'error',
        container: themeColors.redToast,
        text: styles.errorText,
        loadingColor: themeColors.redToastText,
        iconName: 'roundClose',
        iconColor: themeColors.redToastText,
        iconSize: 'M',
      };
    case 'removed':
      return {
        type: 'removed',
        container: themeColors.orangeToast,
        text: styles.removedText,
        loadingColor: themeColors.orangeToastText,
        iconName: 'roundExclamation',
        iconColor: themeColors.orangeToastText,
        iconSize: 'M',
      };
    default:
      return {
        type: 'success',
        container: themeColors.greenToast,
        text: styles.successText,
        loadingColor: themeColors.greenToastText,
        iconName: 'roundCheck',
        iconColor: themeColors.greenToastText,
        iconSize: 'L',
        iconStyle: { paddingTop: 20 },
      };
  }
};

let styles = StyleSheet.create({
  successText: {
    color: themeColors.greenToastText,
    padding: 5,
  },
  removedText: {
    color: themeColors.orangeToastText,
    padding: 5,
  },
  errorText: {
    color: themeColors.redToastText,
    padding: 5,
  },
  contentContainer: {
    paddingHorizontal: 10,
    paddingVertical: 5,
    flexDirection: 'row',
    alignItems: 'center',
  },
});
